import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import TicketList from './TicketList';
import CreateTicket from './CreateTicket';

interface TicketsModuleProps {
  domain: string;
  onBack: () => void;
}

const TicketsModule: React.FC<TicketsModuleProps> = ({ domain, onBack }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>('open');

  React.useEffect(() => {
    const path = location.pathname;
    if (path.includes('/create')) setActiveTab('create');
    else if (path.includes('/closed')) setActiveTab('closed');
    else setActiveTab('open');
  }, [location.pathname]);

  const renderContent = () => {
    switch (activeTab) {
      case 'open':
        return <TicketList domain={domain} statusFilter="open" />;
      case 'closed':
        return <TicketList domain={domain} statusFilter="closed" />;
      case 'create':
        return <CreateTicket domain={domain} onCreated={() => { setActiveTab('open'); navigate('/dashboard/tickets'); }} />;
      default:
        return <TicketList domain={domain} statusFilter="open" />;
    }
  };

  return (
    <div className="min-vh-100 bg-light">
      {/* Header */}
      <div className="bg-primary-custom text-white p-3 shadow-sm">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <h4 className="mb-0">
            <i className="bi bi-ticket-detailed-fill me-2"></i>
            Complaint Box
          </h4>
          <button className="btn btn-light btn-sm" onClick={onBack}>
            <i className="bi bi-arrow-left me-2"></i>Back to Dashboard
          </button>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="bg-white shadow-sm">
        <div className="container-fluid">
          <ul className="nav nav-tabs border-0">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'open' ? 'active' : ''}`}
                onClick={() => { setActiveTab('open'); navigate('/dashboard/tickets'); }}
              >
                <i className="bi bi-exclamation-circle me-2"></i>Open Tickets
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'closed' ? 'active' : ''}`}
                onClick={() => { setActiveTab('closed'); navigate('/dashboard/tickets/closed'); }}
              >
                <i className="bi bi-check-circle me-2"></i>Closed Tickets
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'create' ? 'active' : ''}`}
                onClick={() => { setActiveTab('create'); navigate('/dashboard/tickets/create'); }}
              >
                <i className="bi bi-plus-circle me-2"></i>Create Ticket
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Content Area */}
      <div className="container-fluid py-4">
        {renderContent()}
      </div>
    </div>
  );
};

export default TicketsModule;
